import React from 'react';

import { useStateValue } from '../state';

import CupSlider from './CupSlider';
import Details from './Details';
import Steps from './Steps';

export default ({
  details,
  quantities,
  steps,
  onChange,
  onClick,
}) => {
  const [{
    cup: {
      count,
    },
  }] = useStateValue();

  return (
    <>
      <div className="page--header">
        <img
          alt=""
          className="img--close"
          src="/images/back-button.svg"
          onClick={() => onClick('back')}
        />
        <div className="page--header-detail">
          <h3 className="page--header-detail-title">How many cups?</h3>
          <p className="page--header-detail-sub">
            Use slider below to adjust the number of cups you’ll be making.
          </p>
        </div>
      </div>
      <div className="page--body">
        <div className="page--body-detail">
          <CupSlider
            cups={count}
            quantities={quantities}
            onChange={onChange}
            onClick={onClick}
          />
          <Details
            cups={count}
            quantities={quantities}
            details={details}
            onClick={onClick}
          />
          <Steps
            cups={count}
            quantities={quantities}
            steps={steps}
          />
        </div>
      </div>
      <div className="page--footer">
        <div className="button-wrapper">
        <div className="page--footer-button" onClick={() => onClick('start')}>
          <span className="page--footer-button-title">
            Start Brewing
          </span>
        </div>
        </div>
      </div>
    </>
  );
}
